<div class="card panel-flat-color secondary-panel flex-panel">
    <div class="panel-flat-header ws-flex-container-horizontal">
        <h3 class="ws-truncate ws-flex-auto"> Batch Summary </h3>
        <div class="ws-flex-none header-button-container">
            @if (canEdit) {
                @if (!editMode) {
                    <button title="Edit" type="button" class="ace-btn has-icon btn-text btn-primary" (click)="edit()">
                        <i class="fa fa-pencil fa-align"></i>
                    </button>
                } @else {
                    <button title="Save" type="button" class="ace-btn has-icon btn-text btn-primary" (click)="save()">
                        <i class="fa fa-save fa-align"></i>
                    </button>
                    <button
                        title="Cancel"
                        type="button"
                        class="ace-btn has-icon btn-text btn-primary"
                        (click)="cancel()"
                    >
                        <i class="fa fa-times fa-align"></i>
                    </button>
                }
            }
        </div>
    </div>
    <div class="panel-flat-body">
        <div class="row payment-detail-header">
            <div class="col-md-3">
                <table style="width: 100%">
                    <tr>
                        <td>Top Level Company:</td>
                        <td>{{ paymentBatch.topLevelCompanyName }}</td>
                    </tr>
                    <tr>
                        <td>Company:</td>
                        <td>{{ paymentBatch.company }}</td>
                    </tr>
                    <tr>
                        <td>Batch Type:</td>
                        @if (isTransmittal) {
                            <td>{{ paymentBatch.batchTypeName }}</td>
                        }
                        @if (!isTransmittal) {
                            <td>{{ paymentBatch.batchTypeName }}&nbsp;&nbsp;&nbsp;[{{ paymentBatch.workflowName }}]</td>
                        }
                    </tr>
                    <tr>
                        <td>Batch #:</td>
                        <td>{{ paymentBatch.batchNo }}</td>
                    </tr>
                    <tr>
                        <td style="vertical-align: top">Description:</td>
                        <td>
                            @if (!canModifyDescription) {
                                <span>{{ paymentBatch.description }}</span>
                            }
                            @if (canModifyDescription) {
                                <textarea
                                    type="text"
                                    rows="3"
                                    maxlength="500"
                                    class="form-control"
                                    [(ngModel)]="paymentBatch.description"
                                >
                                </textarea>
                            }
                        </td>
                    </tr>
                </table>
            </div>
            <div class="col-md-5">
                <table>
                    <tr>
                        <td>Total Payments:</td>
                        <td>{{ paymentBatch.paymentCount }}</td>
                    </tr>
                    <tr>
                        <td>Total Payment Amount:</td>
                        <td>{{ paymentBatch.paymentAmount | currency }}</td>
                    </tr>
                    @if (!isTransmittal) {
                        <tr>
                            <td [style.vertical-align]="canModifyFundedAmount ? 'middle' : 'top'"
                                >Total Funded Amount:
                            </td>
                            <td>
                                @if (!canModifyFundedAmount) {
                                    <span>{{ paymentBatch.fundedAmount | currency }}</span>
                                }
                                @if (canModifyFundedAmount) {
                                    <ws-currency-input [hasMargin]="false" [(ngModel)]="paymentBatch.fundedAmount">
                                    </ws-currency-input>
                                }
                                @if (workflowStatus?.reportPartialFunding) {
                                    <span style="margin: 10px; color: var(--ace-danger)">
                                        Payment Batch was advanced with partial Funded Amount.
                                    </span>
                                }
                            </td>
                        </tr>
                    }
                    <tr>
                        <td>Earliest Due Date:</td>
                        <td>
                            @if (paymentBatch.earliestDueDate) {
                                <div>
                                    {{ paymentBatch.earliestDueDate | weissmanDateFormat }}
                                </div>
                            }
                        </td>
                    </tr>
                    @if (!isTransmittal) {
                        <tr>
                            <td>Funding Due Date:</td>
                            <td>
                                @if (paymentBatch.fundingDueDate) {
                                    <div>
                                        {{ paymentBatch.fundingDueDate | weissmanDateFormat }}
                                    </div>
                                }
                            </td>
                        </tr>
                    }
                </table>
            </div>
            <div
                class="col-md-4"
                style="display: flex; flex-direction: column; align-items: start; justify-content: end; gap: 20px"
            >
                @if (paymentBatch.paymentAmount === 0) {
                    <div style="color: var(--ace-danger)">
                        Payment Batch cannot be advanced; total payment amount of Batch is $0.
                    </div>
                }
                @if (paymentBatch.isCheckFeedDirty) {
                    <div style="color: var(--ace-danger)">
                        A change was made to Payments of the Batch that may have invalidated the AP and Check Feeds.
                        Regeneration of the feeds is recommended.
                    </div>
                }
                @if (paymentBatch.isAPFeedDirty && !paymentBatch.isCheckFeedDirty) {
                    <div style="color: var(--ace-danger)">
                        A change was made to Payments of the Batch that may have invalidated the AP Feed. Regeneration
                        of the feed is recommended.
                    </div>
                }
                @if (isTaskAdvanceConfirmFunding && paymentBatch.paymentAmount < paymentBatch.fundedAmount) {
                    <div style="color: var(--ace-danger)">
                        Payment Batch cannot be advanced; total payment amount of Batch is less than the funded amount.
                    </div>
                }
                <div>
                    @if (isPaymentGridActive) {
                        <button
                            class="ace-btn btn-sm btn-primary"
                            (click)="launchAddPaymentsModal()"
                            [disabled]="!workflowStatus?.canAddDeletePayments"
                            helpTooltip
                            helpContentId="payment-batch-details.add-payments-button"
                        >
                            Add Payment
                        </button>
                    }
                    <div style="display: inline-block">
                        @if (workflowStatus?.canImportChecks) {
                            <button type="button" (click)="importChecks()" class="ace-btn btn-sm btn-primary">
                                Import Checks
                            </button>
                        }
                        @if (workflowStatus?.canFinalizeCheckImport) {
                            <button type="button" (click)="finalizeCheckImport()" class="ace-btn btn-sm btn-primary">
                                Finalize Check Import
                            </button>
                        }
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
